import { render, staticRenderFns } from "./SelectTuevsMetodo.vue?vue&type=template&id=11e83851&scoped=true&"
import script from "./SelectTuevsMetodo.vue?vue&type=script&lang=js&"
export * from "./SelectTuevsMetodo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e83851",
  null
  
)

export default component.exports